// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: auto;
}
ion-col {
  padding: var(--spacing-small);
}

ion-input.operatorInput {
  width: 100%;
  font-size: var(--font-size-small);
}
ion-input.operatorInput ::ng-deep .label-text-wrapper.sc-ion-input-md .label-text.sc-ion-input-md {
  opacity: 0.8;
}

ion-scroll {
  height: 100%;
}

.checkItem {
  border-color: #acabab;
  border-width: thin;
  border-style: solid;
  border-radius: 3px;
  color: #6b6a6a;
  font-size: var(--font-size-small);
  height: 100%;
  align-items: center;
  align-content: center;
  --padding-start: var(--spacing-small);
  --padding-end: 0;
}
.checkItem::part(native) {
  --padding-start: var(--spacing-small);
  --padding-end: var(--spacing-small);
  --inner-padding-end: 0;
}

ion-checkbox::part(label) {
  margin: 0;
}

ion-select.select-popover {
  font-size: var(--font-size-small);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  ion-select.select-popover,
  ion-input.operatorInput {
    height: 40px;
    min-height: 40px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 30px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 30px;
    --min-height: 30px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 30px;
    height: 30px;
  }
  ion-input.operatorInput {
    font-size: var(--font-size-medium);
  }
  .checkItem {
    --min-height: 40px;
  }
  ion-checkbox {
    --size: 10px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-select.select-popover,
  ion-input.operatorInput {
    height: 48px;
    min-height: 48px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 40px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 40px;
    --min-height: 40px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 40px;
    height: 40px;
  }
  .checkItem {
    --min-height: 48px;
  }
  ion-checkbox {
    --size: 14px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  ion-select.select-popover,
  ion-input.operatorInput {
    height: 56px;
    min-height: 56px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 48px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 48px;
    --min-height: 48px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 48px;
    height: 48px;
  }
  .checkItem {
    --min-height: 56px;
  }
  ion-checkbox {
    --size: 18px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/operator-form/operator-form-components/operator-info/operator-info.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAEA;EACE,6BAAA;AAAF;;AAGA;EACI,WAAA;EACA,iCAAA;AAAJ;AAGM;EACE,YAAA;AADR;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iCAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EAEA,qCAAA;EACA,gBAAA;AAJF;AAKE;EACE,qCAAA;EACA,mCAAA;EACA,sBAAA;AAHJ;;AAQE;EACE,SAAA;AALJ;;AASA;EACE,iCAAA;AANF;;AASA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EACE;;IAEE,YAAA;IACA,gBAAA;EARJ;EAWE;IACE,iBAAA;IACA,kBAAA;EATJ;EAaQ;IACE,YAAA;IACA,kBAAA;EAXV;EAYU;IACE,gBAAA;IACA,YAAA;EAVZ;EAiBE;IACE,kCAAA;EAfJ;EAkBE;IACE,kBAAA;EAhBJ;EAmBE;IACE,YAAA;EAjBJ;AACF;AAoBA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;;IAEE,YAAA;IACA,gBAAA;EApBJ;EAuBE;IACE,iBAAA;IACA,kBAAA;EArBJ;EAyBQ;IACE,YAAA;IACA,kBAAA;EAvBV;EAwBU;IACE,gBAAA;IACA,YAAA;EAtBZ;EA6BE;IACE,kBAAA;EA3BJ;EA8BE;IACE,YAAA;EA5BJ;AACF;AA+BA,4BAAA;AAEA,yBAAA;AAEC,8DAAA;AACC;EACE;;IAEE,YAAA;IACA,gBAAA;EA/BJ;EAkCE;IAEE,iBAAA;IACA,kBAAA;EAjCJ;EAqCQ;IACE,YAAA;IACA,kBAAA;EAnCV;EAoCU;IACE,gBAAA;IACA,YAAA;EAlCZ;EAyCE;IACE,kBAAA;EAvCJ;EA0CE;IACE,YAAA;EAxCJ;AACF;AA2CA,4BAAA","sourcesContent":["@page{\r\n    size: auto;\r\n}\r\n\r\nion-col {\r\n  padding: var(--spacing-small);\r\n}\r\n\r\nion-input.operatorInput {\r\n    width: 100%;\r\n    font-size: var(--font-size-small);\r\n\r\n    ::ng-deep .label-text-wrapper.sc-ion-input-md {\r\n      .label-text.sc-ion-input-md {\r\n        opacity: 0.8;\r\n      }\r\n    }\r\n}\r\n\r\nion-scroll {\r\n    height: 100%;\r\n}\r\n\r\n.checkItem {\r\n  border-color: #acabab;\r\n  border-width: thin;\r\n  border-style: solid;\r\n  border-radius: 3px;\r\n  color: #6b6a6a;\r\n  font-size: var(--font-size-small);\r\n  height: 100%;\r\n  align-items: center;\r\n  align-content: center;\r\n\r\n  --padding-start: var(--spacing-small);\r\n  --padding-end: 0;\r\n  &::part(native) {\r\n    --padding-start: var(--spacing-small);\r\n    --padding-end: var(--spacing-small);\r\n    --inner-padding-end: 0;\r\n  }\r\n}\r\n\r\nion-checkbox{\r\n  &::part(label) {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\nion-select.select-popover {\r\n  font-size: var(--font-size-small);\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 599px) {\r\n    ion-select.select-popover,\r\n    ion-input.operatorInput {\r\n      height: 40px;\r\n      min-height: 40px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover {\r\n      --max-width: auto;\r\n      --max-height: 30px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 30px;\r\n            --min-height: 30px;\r\n            &::part(native) {\r\n              min-height: 30px;\r\n              height: 30px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    ion-input.operatorInput {\r\n      font-size: var(--font-size-medium);\r\n    }\r\n\r\n    .checkItem {\r\n      --min-height: 40px;\r\n    }\r\n\r\n    ion-checkbox {\r\n      --size: 10px;\r\n    }\r\n  }\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    ion-select.select-popover,\r\n    ion-input.operatorInput {\r\n      height: 48px;\r\n      min-height: 48px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover {\r\n      --max-width: auto;\r\n      --max-height: 40px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 40px;\r\n            --min-height: 40px;\r\n            &::part(native) {\r\n              min-height: 40px;\r\n              height: 40px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .checkItem {\r\n      --min-height: 48px;\r\n    }\r\n\r\n    ion-checkbox {\r\n      --size: 14px;\r\n    }\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1024px) {\r\n    ion-select.select-popover,\r\n    ion-input.operatorInput {\r\n      height: 56px;\r\n      min-height: 56px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover\r\n    {\r\n      --max-width: auto;\r\n      --max-height: 48px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 48px;\r\n            --min-height: 48px;\r\n            &::part(native) {\r\n              min-height: 48px;\r\n              height: 48px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .checkItem {\r\n      --min-height: 56px;\r\n    }\r\n\r\n    ion-checkbox {\r\n      --size: 18px;\r\n    }\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
